import { TabsComponent } from '@/app/shared/tabs/tabs.component';
import { CommonModule } from '@angular/common';
import { Component, Input, signal, output, Output, EventEmitter, effect } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Rpt, RptsResponse } from '@/app/interfaces/accession';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { PaginationComponent } from '@/app/shared/pagination/pagination.component';
import { ButtonModule } from 'primeng/button';
import { DesyAngularModule } from 'desy-angular';
import { RptsService } from '@/app/services/rpts.service';
import { SearchBarComponent } from '@/app/shared/search-bar/search-bar.component';
@Component({
  selector: 'app-step4',
  imports: [
    SearchBarComponent,
    DesyAngularModule,
    ButtonModule,
    CommonModule,
    TabsComponent,
    TableModule,
    ButtonsComponent,
    PaginationComponent,
  ],
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.scss'],
  standalone: true,
})
export class Step4Component {
  @Input() nameAndRange: string = '';
  @Input() addedRpts: Rpt[] = [];
  jobCode = JSON.parse(localStorage.getItem('userData')).roleCode;

  rptsAll!: Rpt[];
  rptsTeams!: Rpt[];

  currentPageAllRpts = signal(1);
  paginationSizeAllRpts = signal(15);
  seachDataAll = signal('');
  totalResultsAll = signal(0);

  paginationSizeTeamsRpts = signal(15);
  currentPageTeamsRpts = signal(1);
  totalResultsTeams = signal(0);
  seachDataTeams = signal('');

  @Output() step4IsValid = new EventEmitter<boolean>();
  constructor(private rptsService: RptsService) {}

  step4Completed = output<Rpt[]>();
  selectedRpts!: Rpt[];
  tabsItems = signal([
    { title: 'RPTs de mi equipo', id: '1' },
    { title: 'RPTs gobierno de Aragon', id: '2' },
  ]);

  selectedTab = signal('1');

  get filterParamsAllRpts() {
    return [
      {
        basicFilter: {
          orderBy: 'asc',
          nameOrderBy: '',
          currentPage: this.currentPageAllRpts(),
          sizePages: this.paginationSizeAllRpts(),
          jobCode: '',
        },
      },
      {
        advanceFilter: {
          search: this.seachDataAll(),
        },
      },
    ];
  }
  get filterParamsTeamsRpts() {
    return [
      {
        basicFilter: {
          orderBy: 'asc',
          nameOrderBy: '',
          currentPage: this.currentPageTeamsRpts(),
          sizePages: this.paginationSizeTeamsRpts(),
          jobCode: this.jobCode,
        },
      },
      {
        advanceFilter: {
          search: this.seachDataTeams(),
        },
      },
    ];
  }

  allRptsEffect = effect(() => {
    this.rptsAll = [];
    this.currentPageAllRpts();
    this.paginationSizeAllRpts();
    this.loadAllRpts();
  });

  teamsRptsEffect = effect(() => {
    this.rptsTeams = [];
    this.currentPageTeamsRpts();
    this.paginationSizeTeamsRpts();
    this.loadTeamsRpts();
  });

  async loadTeamsRpts() {
    const { data }: RptsResponse = await this.rptsService.getRpts(this.filterParamsTeamsRpts);
    if (data.items?.length) {
      this.rptsTeams = data.items;
    } else {
      this.rptsTeams = [];
    }
    if (data?.total) {
      this.totalResultsTeams.set(data.total);
    } else {
      this.totalResultsTeams.set(0);
    }
  }

  async loadAllRpts() {
    const { data }: RptsResponse = await this.rptsService.getRpts(this.filterParamsAllRpts);
    if (data.items.length) {
      this.rptsAll = data.items;
    } else {
      this.rptsAll = [];
    }
    if (data?.total) {
      this.totalResultsAll.set(data.total);
    } else {
      this.totalResultsAll.set(0);
    }
  }

  handleSearchTeam(value: string) {
    this.seachDataTeams.set(value);
  }

  handleSearchAll(value: string) {
    this.seachDataAll.set(value);
  }

  emitStep4Data() {
    this.step4Completed.emit(this.addedRpts);
  }

  onTabChange(tabId: string) {
    this.selectedTab.set(tabId);
  }

  addRpts() {
    this.addedRpts = this.selectedRpts;
    this.checkValidity();
  }

  removeRpt(jobCode: string) {
    this.addedRpts = this.addedRpts.filter((rpt) => rpt.jobCode !== jobCode);
    this.checkValidity();
  }

  private checkValidity() {
    const isValid = this.addedRpts && this.addedRpts.length > 0;
    this.step4IsValid.emit(isValid);
  }

  selectRpt(e) {
    if (this.selectedTab() === '1') {
      this.selectedRpts = this.rptsTeams.filter((rpt) => e[rpt.jobCode] === true);
    } else {
      this.selectedRpts = this.rptsAll.filter((rpt) => e[rpt.jobCode] === true);
    }
  }
}
